import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, INTERVIEWS} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {SeoIntrup} from '@layouts/SeoLayout';
import {isCSR} from '@jobseeker/lotus/utils';
import {Chat, InjectSearchOverlay} from '@components';
import {TrackEventUBA} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {AppState} from '@jobseeker/common-core/types';
import dynamic from 'next/dynamic';

const PLATFORM = process.env.NEXT_PUBLIC_APP_NAME;

const Interviews = dynamic(() =>
  PLATFORM === 'iimjobs'
    ? import('@components/Interview/Interviews')
    : import('@jobseeker/feature-job/components/Interview/Hirist/interviews')
);

type InterviewProps = {
  seoConfig: object;
};

const MyInterviews = ({seoConfig}: InterviewProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, INTERVIEWS);

  const isSearchEnabled = useSelector(
    (state: AppState) => state.app.layout.searchOverlay,
    shallowEqual
  );

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch, true);
  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Interviews',
      item: '/interviews',
    },
  ];

  const router = useRouter();
  useEffect(() => {
    TrackEventUBA('interviewPageView', 'view', {
      filterStatus: router.query.booked || '',
      ref: router.query.ref || '',
      pageName: 'Interview Page',
      sessionUsername: `${sessionStorage.getItem('userId')}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Interceptor metaInfo={metaData}>
        <SeoLayout seoConfig={seoConfig} />
        <NavLayout>
          <ResponsiveLayout
            breadcrumbElements={PLATFORM === 'hirist' ? [] : breadcrumbElements}
            variant={VersionVariants.VERSION_TWO}
          >
            {isCSR() && (
              <SeoIntrup pageNo={0} nextPage={false} type={INTERVIEWS} />
            )}
            <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
            <Interviews />
          </ResponsiveLayout>
        </NavLayout>
      </Interceptor>
      <Chat />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    const seoConfig = await loadSEO(INTERVIEWS);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: INTERVIEWS},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default MyInterviews;
